<template>
  <a-modal
    v-model="currentVisible"
    :footer="null"
    width="820px"
    :closable="false"
    :afterClose="
      () => {
        $store.commit('SWITCH_IS_SHOW_COMPETE_SYSTEM', false)
      }
    "
    wrapClassName="improveSystemModal"
    :maskClosable="false"
    :keyboard="false"
  >
    <div class="improveSystemModal_title">
      <span />
      <span>{{ $t('完善企业云展系统') }}</span>
      <a-icon
        type="close"
        @click="
          () => {
            $store.commit('SWITCH_IS_SHOW_COMPETE_SYSTEM', false)
          }
        "
      />
    </div>
    <div class="improveSystemModal_info">
      <div class="leftCont">
        <h3>{{ $t('企业云展系统') }} <span>=</span> {{ $t('获客营销神器') }}</h3>
        <div class="ul">
          <div class="li">
            {{ $t('足不出户带客户同逛企业') }}
          </div>
          <div class="li">
            {{ $t('与全球客户实时洽谈互动') }}
          </div>
          <div class="li">
            {{ $t('智能推送精准客户') }}
          </div>
          <div class="li">
            {{ $t('实时掌握访问数据') }}
          </div>
        </div>
        <a-button class="button" type="primary" style="width: 144px" @click="toEditSystem">
          {{ $t('去完善') }}
        </a-button>
      </div>
      <img
        src="https://resource668.oss-cn-shenzhen.aliyuncs.com/website/image/default/improveSystemModalBg.png"
        :alt="$t('企业云展系统')"
        class="bgImg"
      />
    </div>
  </a-modal>
</template>

<script>
// 新会员注册后的提示框
import { mapGetters } from 'vuex'

export default {
  name: 'ImproveSystemModal',
  model: {
    prop: 'visible',
    event: 'visibleChange',
  },
  props: {
    visible: Boolean,
  },
  data() {
    return {
      buttonDisabled: true,
    }
  },
  computed: {
    ...mapGetters({
      userInfo: 'userInfo',
    }),
    currentVisible: {
      get() {
        return this.visible
      },
    },
  },
  mounted() {},
  methods: {
    toEditSystem() {
      this.$store.commit('SWITCH_IS_SHOW_COMPETE_SYSTEM', false)
      this.$router.push(`/${this.userInfo.primaryMemberCode}`)
    },
  },
}
</script>

<style lang="scss">
.improveSystemModal {
  .ant-modal-content {
    background-image: url('https://resource668.oss-cn-shenzhen.aliyuncs.com/website/image/default/pic_wenxts.png');
    background-repeat: no-repeat;
    overflow: hidden;
    background-position: center top;
    .ant-modal-body {
      padding: 18px;
      height: 490px;
      display: flex;
      flex-direction: column;
    }
  }

  &_title {
    display: flex;
    justify-content: baseline;
    color: #ff6600;
    font-size: 20px;
    text-align: center;
    font-weight: bold;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  &_info {
    padding: 0 60px 0 60px;
    margin-top: 40px;
    color: #333333;
    display: flex;
    align-items: center;
    height: 100%;
    .leftCont {
      h3 {
        font-size: 18px;
        font-weight: 500;
        color: #333333;
        line-height: 25px;
        span {
          color: #ff6600;
        }
      }
      .ul {
        margin-top: 10px;
        margin-bottom: 20px;
        line-height: 36px;
        .li:before {
          content: '♦';
          color: #ff6600;
          font-size: 8px;
          margin-right: 6px;
        }
      }
    }
    .bgImg {
      position: absolute;
      right: 0;
      bottom: 0;
      width: 458px;
      height: 367px;
    }
  }
  &_buttonBox {
    display: flex;
    justify-content: center;
    margin-top: 30px;
    margin-bottom: 10px;
    .ant-btn-lg {
      padding: 0 50px;
    }
  }
}
</style>
